import OutlinedUI from './OutlinedUI'
import { ColoredOutlinedUI } from './styles'

export { ColoredOutlinedUI }
export default OutlinedUI
